import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import AddonsData from "../Data/AddonsData.json";
import AddonsVideoImg from "../Assets/img/addons/addons-details/addons-video-img.png";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// import required modules
import { Autoplay, Navigation } from "swiper";

import BreadSliderImg from "../Assets/img/addons/addons-details/addons-details-bred-img.png";
import VideoPlayerPopup from "../Components/VideoPlayerPopup";
import { Link } from "react-router-dom";

const AddonsDetails = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const BreadcrumbsSlider = [
    {
      id: "slider1",
      img: BreadSliderImg,
    },
    {
      id: "slider2",
      img: BreadSliderImg,
    },
  ];

  return (
    <>
      {/* <!-- Breadcrumbs --> */}
      <section className="breadcrumbs breadcrumbs__addons breadcrumbs__addons-details">
        <div className="container">
          <div className="row d-flex align-items-center">
            {/* <!-- Breadcrumbs-Menu --> */}
            <div className="col-lg-5 col-md-6 col-12">
              <div className="breadcrumbs__content">
                <a href="offer-page.html" className="back-addons-btn">
                  <i className="fa fa-angle-left"></i>Back to add-ons
                </a>
                <h4 className="breadcrumbs__price">
                  Price: <b>$5</b> /month
                </h4>
                <h2 className="breadcrumbs__title">
                  E-commerce product carousel
                </h2>
                <p className="breadcrumbs__text">
                  by{" "}
                  <a href="#" target="_blank">
                    SoftifyBD
                  </a>
                </p>
              </div>
              <div className="breadcrumbs__btn">
                <Link to="#" className="theme-btn theme-white">
                  <i className="fa fa-shopping-cart"></i>Request to order
                </Link>
              </div>
            </div>
            <div className="col-lg-6 offset-lg-1 col-md-6 col-12">
              <div className="breadcrumbs__img_slider">
                <Swiper
                  navigation={true}
                  modules={[Navigation, Autoplay]}
                  spaceBetween={30}
                  slidesPerView={1}
                  loop={true}
                  autoplay={true}
                >
                  {BreadcrumbsSlider.map((SingleSlider) => (
                    <SwiperSlide key={SingleSlider.id}>
                      <div className="breadcrumbs__img">
                        <img src={SingleSlider.img} alt="#" />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End Breadcrumbs --> */}

      {/* <!-- Addons Details area --> */}
      <section className="addons-single sf-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-xl-8 col-12">
              {/* <!-- Tab Menu --> */}
              <div className="addons-single__tabs">
                <ul className="list-group" id="list-tab" role="tablist">
                  <li>
                    <a
                      className="list-group-item active"
                      data-bs-toggle="list"
                      href="#tab1"
                      role="tab"
                    >
                      Description
                    </a>
                  </li>
                  <li>
                    <a
                      className="list-group-item"
                      data-bs-toggle="list"
                      href="#tab2"
                      role="tab"
                    >
                      Installation guide
                    </a>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="nav-tabContent">
                {/* <!-- Property Tab One --> */}
                <div
                  className="tab-pane fade show active"
                  id="tab1"
                  role="tabpanel"
                >
                  <p>
                    Tellus vitae enim blandit dui. Risus at ultricies ornare
                    vitae mollis est arcu sociis. Vitae pharetra ut aenean cras.
                    Malesuada nulla elementum lorem faucibus faucibus. Odio
                    neque auctor mauris parturient sit egestas. Integer
                    phasellus sit accumsan scelerisque sed ac et. Cras id quam
                    sit aliquam placerat sem lorem consequat sed.
                  </p>
                  <p>
                    Commodo eget congue turpis mattis nulla. Ac ultrices sem est
                    enim sed platea. Sed pellentesque felis purus gravida odio
                    egestas. Pellentesque tortor, ac quam porta. Neque pretium,
                    at pretium mauris, pellentesque. Magna blandit cursus
                    ullamcorper congue. Consequat, in ut ut faucibus erat tempor
                    at quis et. Massa sit consequat lacus lacus. Pharetra sed
                    sollicitudin gravida velit sagittis. Non suspendisse commodo
                    ac a viverra. Magna magna risus, faucibus ac facilisis
                    fringilla tellus dignissim sed.
                  </p>
                  <div className="addons-single_video overlay">
                    <img src={AddonsVideoImg} alt="es-png.png" />
                    <div className="video-play">
                      <VideoPlayerPopup />
                    </div>
                  </div>
                  <div className="list-features-main">
                    <h4 className="addons-single__title">Features</h4>
                    <ul className="addons-single__single-list">
                      <li className="margin-right">
                        <i className="fa fa-check"></i>Easy to use and
                        customization
                      </li>
                      <li>
                        <i className="fa fa-check"></i>10 styles slider
                        templates with drag and drop features
                      </li>
                      <li className="margin-right">
                        <i className="fa fa-check"></i>Carousel Settings
                        Navigation & Slides To Show
                      </li>
                      <li>
                        <i className="fa fa-check"></i>Ut ut praesent urna eget.
                        Blandit aenean.
                      </li>
                      <li>
                        <i className="fa fa-check"></i>Lectus faucibus dictum
                        euismod pulvinar ut.
                      </li>
                      <li className="margin-right">
                        <i className="fa fa-check"></i>Ready made template with
                        awesome styles
                      </li>
                      <li>
                        <i className="fa fa-check"></i>Developer friendly & easy
                        to customize.
                      </li>
                      <li className="margin-right">
                        <i className="fa fa-check"></i>Consectetur sagittis,
                        suspendisse at nec lobortis id. Venenatis tempor mauris
                        sit sem.
                      </li>
                      <li>
                        <i className="fa fa-check"></i>Malesuada et nisl lectus
                        et sodales.
                      </li>
                      <li>
                        <i className="fa fa-check"></i>Developer friendly & easy
                        to customize.
                      </li>
                      <li>
                        <i className="fa fa-check"></i>Tristique arcu luctus
                        neque non volutpat.
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <!-- Property Tab Two --> */}
                <div className="tab-pane fade" id="tab2" role="tabpanel">
                  <p>
                    Tellus vitae enim blandit dui. Risus at ultricies ornare
                    vitae mollis est arcu sociis. Vitae pharetra ut aenean cras.
                    Malesuada nulla elementum lorem faucibus faucibus. Odio
                    neque auctor mauris parturient sit egestas. Integer
                    phasellus sit accumsan scelerisque sed ac et. Cras id quam
                    sit aliquam placerat sem lorem consequat sed.
                  </p>
                  <p>
                    Commodo eget congue turpis mattis nulla. Ac ultrices sem est
                    enim sed platea. Sed pellentesque felis purus gravida odio
                    egestas. Pellentesque tortor, ac quam porta. Neque pretium,
                    at pretium mauris, pellentesque. Magna blandit cursus
                    ullamcorper congue. Consequat, in ut ut faucibus erat tempor
                    at quis et. Massa sit consequat lacus lacus. Pharetra sed
                    sollicitudin gravida velit sagittis. Non suspendisse commodo
                    ac a viverra. Magna magna risus, faucibus ac facilisis
                    fringilla tellus dignissim sed.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-xl-3 offset-xl-1 col-12">
              <div className="addons-single__left-content">
                <div className="addons-single-left-btn">
                  <Link to="#" className="theme-btn theme-white">
                    <i className="fa fa-shopping-cart"></i>Request to order
                  </Link>
                </div>
                <div className="addons-single__list">
                  <h4 className="addons-single__list-title">About add-ons</h4>
                  <ul>
                    <li>
                      <span className="list-name">Developer</span>
                      <b>SoftifyBD</b>
                    </li>
                    <li>
                      <span className="list-name">Version</span>
                      <b>1.0.2</b>
                    </li>
                    <li>
                      <span className="list-name">Added</span>
                      <b>15 Oct 2021</b>
                    </li>
                    <li>
                      <span className="list-name">Updated</span>
                      <b>1 week ago</b>
                    </li>
                    <li>
                      <span className="list-name">Documentation</span>
                      <b>YES</b>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h4 className="addons-single__title addons-single__two">
                Related add-ons
              </h4>
              <div class="row">
                {AddonsData.slice(0, 4).map((AddonsSingle) => (
                  <div
                    className="col-lg-3 col-md-6 col-12"
                    key={AddonsSingle.id}
                  >
                    <Link to="#">
                      <div className="addons__single">
                        {/* <!-- Addons Head --> */}
                        <div className="addons__head">
                          <div className="addons__img">
                            <img src={AddonsSingle.img} alt="#" />
                            <p className="addons__badge">
                              {AddonsSingle.addonsbadge}
                            </p>
                          </div>
                        </div>
                        {/* <!-- Addons Body --> */}
                        <div className="addons__body">
                          <div className="addons__content">
                            <h3 className="addons__price">
                              <span>{AddonsSingle.addonsprice}</span>{" "}
                              {AddonsSingle.addonsdurations}
                            </h3>
                          </div>
                          <h4 className="addons__single-title">
                            {AddonsSingle.title}
                          </h4>
                          <Link className="addons__single-btn" to="#">
                            Read more
                          </Link>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End Addons Details area --> */}
    </>
  );
};

export default AddonsDetails;
